import AddCircle from '@mui/icons-material/AddCircle';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import { FormHelperText, Typography } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import Handler from '../../Handler';
import { FormInputLabel } from './FormInputLabel';

export const FormFileContent = ({ file, name, label, error, setValue, onClick, ...rest }) => {
  const [currentFile, setCurrentFile] = useState(null);

  const isUrl = useMemo(() => {
    return Handler.isUrl(file);
  }, [file]);

  useEffect(() => {
    if (file && isUrl) {
      const getBlob = async () => {
        try {
          const response = await fetch(file);
          const blob = await response.blob();

          // URL에서 파일명 추출
          const urlPath = new URL(file).pathname;
          const fileName = urlPath.substring(urlPath.lastIndexOf('/') + 1) || 'file';

          // blob을 File 객체로 변환
          const fileObject = new File([blob], fileName, { type: blob.type });

          // File 객체를 setValue로 설정
          if (name) {
            setCurrentFile(fileObject);
          }
        } catch (error) {
          console.error('Error converting blob to file:', error);
        }
      };
      getBlob();
    }
  }, [file, isUrl]);

  const renderFileContent = useMemo(() => {
    if (!file) {
      return (
        <div className='border border-solid border-gray-300 p-4 rounded-md cursor-pointer' onClick={onClick}>
          <div className='flex items-center gap-2'>
            <AddCircle />
            <div>
              <Typography
                sx={{
                  fontSize: '13px',
                  fontWeight: 500,
                  lineHeight: '20px',
                }}
              >
                파일 업로드
              </Typography>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className='border bg-slate-100 rounded-md p-3 flex items-center justify-between cursor-pointer'>
        <div className='flex items-center gap-2'>
          <AttachFileIcon />
          <div>
            <Typography
              sx={{
                fontSize: '13px',
                fontWeight: 500,
                lineHeight: '20px',
              }}
            >
              {currentFile ? currentFile?.name : file?.name}
            </Typography>
            <Typography
              sx={{
                fontSize: '12px',
              }}
            >
              {currentFile ? currentFile?.size : file?.size}
            </Typography>
          </div>
        </div>
        <div className='flex items-center gap-2'>
          <CheckCircleIcon
            sx={{
              color: '#00C853',
            }}
          />
          <DeleteIcon
            onClick={(e) => {
              e.stopPropagation();
              setValue(name, null);
            }}
          />
        </div>
      </div>
    );
  }, [file, name, setValue, onClick]);

  return (
    <div className='flex flex-col gap-1'>
      {label && <FormInputLabel label={label} isRequired={rest.required} />}
      {renderFileContent}
      {error && <FormHelperText error>{error.message}</FormHelperText>}
    </div>
  );
};
